import { Col, Row } from 'antd';
import { useTranslation } from 'react-i18next';
import { type BasicSigningModuleSpecsFragment } from '../../../../../api/fragments/BasicSigningModuleSpecs';
import {
    CreateBasicSigningModuleDocument,
    type CreateBasicSigningModuleMutation,
    type CreateBasicSigningModuleMutationVariables,
} from '../../../../../api/mutations/createBasicSigningModule';
import { type BasicSigningModuleSettings } from '../../../../../api/types';
import InputField from '../../../../../components/fields/InputField';
import InputNumberField from '../../../../../components/fields/InputNumberField';
import SelectField from '../../../../../components/fields/SelectField';
import useSystemOptions from '../../../../../utilities/useSystemOptions';
import BasicSigningModulePage, { type BasicSigningModuleProps } from '../../BasicSigningModuleDetailPage';
import { OTPFormValidator } from '../../BasicSigningModuleDetailPage/UpdateForm';
import { type ModuleImplementation } from './types';

const colSpan = { lg: 8, md: 12, xs: 24 };

const implementation: ModuleImplementation<BasicSigningModuleSpecsFragment, BasicSigningModuleSettings> = {
    PageComponent: ({ module }: BasicSigningModuleProps) => <BasicSigningModulePage module={module} />,
    getTitle: t => t('moduleDetails:implementations.BasicSigningModule.className'),
    FormComponent: () => {
        const { t } = useTranslation(['basicSigningModuleDetails']);
        const { transportProtocolOptions } = useSystemOptions();

        return (
            <Row gutter={[14, 14]}>
                <Col {...colSpan}>
                    <InputField
                        {...t('basicSigningModuleDetails:updateDrawer.fields.displayName', {
                            returnObjects: true,
                        })}
                        name="displayName"
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <InputNumberField
                        {...t('basicSigningModuleDetails:updateDrawer.fields.lifeTime', {
                            returnObjects: true,
                        })}
                        max={10}
                        min={1}
                        name="lifeTime"
                        required
                    />
                </Col>
                <Col {...colSpan}>
                    <SelectField
                        {...t('basicSigningModuleDetails:updateDrawer.fields.transportProtocol', {
                            returnObjects: true,
                        })}
                        name="transportProtocol"
                        options={transportProtocolOptions}
                        required
                        showSearch
                    />
                </Col>
            </Row>
        );
    },
    getValidator: () => OTPFormValidator,
    create: async (apolloClient, companyId, values) =>
        apolloClient
            .mutate<CreateBasicSigningModuleMutation, CreateBasicSigningModuleMutationVariables>({
                mutation: CreateBasicSigningModuleDocument,
                variables: { companyId, settings: values },
            })
            .then(({ data }) => data.module),
};

export default implementation;
